import Component, { ComponentAttrs } from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import User from 'flarum/common/models/User';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import icon from 'flarum/common/helpers/icon';
import { ApiPayloadPlural } from 'flarum/common/Store';

export default class PointsRanking extends Component<ComponentAttrs> {
  loading = true;

  users: User[] = [];

  oninit(vnode: any) {
    super.oninit(vnode);
    this.queryUsers();
  }

  queryUsers() {
    this.loading = true;
    m.redraw();

    app
      .request<ApiPayloadPlural>({
        url: app.forum.attribute('apiUrl') + '/users',
        method: 'GET',
        params: {
          'filter[q]': '',
          'page[limit]': 10,
          'page[offset]': 0,
          sort: '-money',
        },
      })
      .then((payload) => {
        this.users = app.store.pushPayload(payload) as any;
      })
      .catch(console.error)
      .finally(() => {
        this.loading = false;
        m.redraw();
      });
  }

  view() {
    return (
      <div className="PointsRanking">
        <div className="PointsRanking-header">
          <div>
            <i class="icon fas fa-sort-numeric-down"></i>
            <span>积分排行</span>
          </div>
        </div>

        {this.content()}
      </div>
    );
  }

  content() {
    if (this.loading) {
      return <LoadingIndicator />;
    }

    if (!this.users.length) {
      return (
        <div className="PointsRanking-content">
          <div></div>
        </div>
      );
    }

    return (
      <div className="PointsRanking-content">
        {this.users.map((user) => (
          <Link key={user.id()} className="PointsRanking-item" href={app.route.user(user)}>
            <div className="PointsRanking-item-avatar">{avatar(user)}</div>
            <div className="PointsRanking-item-content">
              <div className="PointsRanking-item-name">{user.displayName()}</div>
              <div className="PointsRanking-item-value">
                {icon('fas fa-gift')} {user.attribute('money')}
              </div>
            </div>
          </Link>
        ))}
      </div>
    );
  }
}
